import {
	AccordionPageSection,
	TileListPageSection,
	TabPivotPageSection,
	PageHeaderSection,
	InfoCardPageSection,
	DoctorAdaptiveContent,
	JoinUsPageSection,
	BannerPageSection,
	CustomPageSectionWrapper,
} from "./sections";
import { contentfulToImageData, getSectionStyling , getContentTypeId} from "./functions";
import { VARIANT_STYLE_MAPPING, NORMAL_VARIANT_STYLES } from "./constants";

const PAGE_SECTION_MAPPING = {
	pageHeaderSection: PageHeaderSection,
	conditionsLandingPageAdaptiveContent: DoctorAdaptiveContent,
	tabPivotPageSection: TabPivotPageSection,
	tileListPageSection: TileListPageSection,
	infoCardPageSection: InfoCardPageSection,
	joinUsPageSection: JoinUsPageSection,
	landingPageBanner: BannerPageSection,
	conditionInformationSection: AccordionPageSection,
	customContentSection: CustomPageSectionWrapper,
};



const formatPageSections = fields => {
	const pageSections = [fields.pageHeader, ...(fields?.pageSections ?? [])];
	return pageSections;
};

const formatPageSectionFields = fields => {
	const formattedImageData = fields.images?.map(image => contentfulToImageData(image)) ?? [];
	const variantStyling = VARIANT_STYLE_MAPPING[fields.variant] || NORMAL_VARIANT_STYLES;
	const formattedSectionStyles = getSectionStyling(fields.sectionStyles, fields.variant);
	const updatedFields = {
		...fields,
		images: formattedImageData,
		variantStyling,
		formattedSectionStyles,
	};
	return updatedFields;
};

const formatHomeHeader = (header, exp, siteStatus) => {
	const avg_wait = siteStatus?.wr_stat?.prediction?.data?.pc_98_wait;
	return exp?.waitTimeExp ? {...header, "fields": {...header?.fields, exp, extraSubtitle: (avg_wait > 15 && avg_wait <= 30) && "*Wait times may vary", "nonStaticComponentIds": ["Wait Time Consult Book"]}} : header;
};

export const registerPageSections = (page, siteStatus, isStatic, parsedFunctions, exp) => {
	if (!page || !page.fields) {
		console.warn("No page or page fields found. Returning empty array.");
		return [];
	}

	const waitTimeExp = page?.fields?.slug === "homepage" && exp?.waitTimeExp?.n === "show_wt";
	const pageSections = formatPageSections({...page.fields, pageHeader: formatHomeHeader(page.fields.pageHeader, {waitTimeExp}, siteStatus)} || page.fields);

	return pageSections.map((section, index) => {
		if (!section) return null;

		const { fields, sys } = section;
		if (!fields || !sys) {
			console.warn(`Skipping section ${index} due to missing fields or sys`);
		}
		const contentTypeId = getContentTypeId(sys);
		if (!contentTypeId) {
			console.warn(`Component ID is missing for section ${fields?.title}. Skipping rendering.`);
			return null;
		}
		const Component = PAGE_SECTION_MAPPING[contentTypeId];
		if (!Component) {
			console.warn(`Component with ID ${contentTypeId} not found for section ${index}`);
			return null;
		}
		const formattedFields = formatPageSectionFields(fields);

		return (
			<Component
				key={index}
				{...formattedFields}
				siteStatus={siteStatus}
				isStatic={isStatic}
				parsedFunctions={parsedFunctions}
				id={sys.id}
			/>
		);
	});
};
